<template>
  <div>
    <h4>{{ $t("login") }}</h4>
    <p class="widget-auth-info">
      {{ $t("useYourEmailToLogin") }}
    </p>
    <login-form redirect-route="chemdashboard" />
    <p class="widget-auth-info">
      <router-link to="/register">{{ $t("createAccount") }}</router-link>
      |
      <router-link to="/password-reset">{{ $t("forgotPassword") }}</router-link>
    </p>
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "LoginChemView",
  components: {
    LoginForm
  }
};
</script>

<style scoped lang="scss"></style>
